import { useBreakpoint } from '@hh.ru/magritte-ui';

import { useSearchSettings } from 'src/hooks/search/useSearchSettings';

export const useDraftClustersLogic = (): boolean => {
    const { isVacancySearchPage } = useSearchSettings();
    const { isMobile } = useBreakpoint();

    return isMobile && isVacancySearchPage;
};
